<template>
  <div class="illnessCrad">
    <div class="title">{{ title }}</div>
    <div class="selectArea">
      <div
        class="illItem"
        :class="{
          noOneSlect: !isCardSelected,
          selceted: isCardSelected && item.selectFlag === 1,
          notSelect: isCardSelected && item.selectFlag === 0
        }"
        v-for="(item, index) in illInfoList"
        :key="index"
      >
        {{ item.illnessName }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    IMConfig: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      title: '',
      illInfoList: []
    }
  },
  computed: {
    isCardSelected() {
      return this.illInfoList.some(item => item.selectFlag === 1)
    }
  },
  mounted() {
    const { tipDesc, illInfoListStr } = this.IMConfig || {}
    this.title = tipDesc
    this.illInfoList = JSON.parse(illInfoListStr || '{}')
  }
}
</script>
<style lang="scss" scoped>
.illnessCrad {
  min-width: 223px;
  padding: 16px 14px;
  background-color: #fff;
  border-radius: 0 8px 8px 8px;

  .title {
    font-weight: 400;
    font-size: 16px;
    color: #1a1a1a;
  }

  .selectArea {
    display: flex;
    flex-wrap: wrap;
    .illItem {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      border-radius: 8px;
      padding: 6px 12px;
      margin: 12px 8px 0 0;
      font-weight: 400;
      font-size: 14px;
    }

    .noOneSlect {
      border: 1px solid #d9d9d9;
      color: #666666;
    }

    .selceted {
      background: #efefef;
      border: 1px solid transparent;
      color: #b2b2b2;
    }

    .notSelect {
      border: 1px solid #efefef;
      color: #d4d4d4;
    }
  }
}
</style>
